// extracted by mini-css-extract-plugin
module.exports = {"container":"packages-core-App-style__container--1jGvV","slide-in-sticky":"packages-core-App-style__slide-in-sticky--3t-bu","buildInfo":"packages-core-App-style__buildInfo--38xGR"};